module.exports = __webpack_public_path__ + "static/Disability-in-the-Bush-English-2020-05-25-f01566e564b5317a90bc86dae9d9db19.mp3";